import { render, staticRenderFns } from "./bakatpilStor.vue?vue&type=template&id=e4d27dfc&scoped=true"
import script from "./bakatpilStor.vue?vue&type=script&lang=js"
export * from "./bakatpilStor.vue?vue&type=script&lang=js"
import style0 from "./bakatpilStor.vue?vue&type=style&index=0&id=e4d27dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d27dfc",
  null
  
)

export default component.exports